import React from 'react';
import { useTranslation } from 'react-i18next';
import {CleanUrl} from "../../utils/cleanUrl";

const Error = () => {

    const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);
    const { t, i18n } = useTranslation();

    return (
        <div className="pweu-error">
            <img src={imagePath + "not-completed.svg"} alt="" />
            <p>{t("Something went wrong. Please try again later.")}</p>
            <a href={window.promotionHome} className="btn btn-primary">{t("Return to Homepage")}</a>
        </div>
    );
};

export default Error;
